import React from "react";
import { Link } from "react-router-dom";
import { URLS } from "../urls";
import currency from "currency.js";
import { Dropdown, Table } from "react-bootstrap";
import { statusColor } from "../../utils";

const EmployeeTable = ({
  showSalary,
  searchEmployeeList,
  startIndex,
  returnDropDownItems,
  DropDowns,
  hideActions,
}) => {
  const getEmployeeDirect = (employee, profileImage) => {
    if (hideActions) {
      return (
        <>
          <div className="table-avatar blue-link">
            <span className="avatar">
              <img alt="" src={profileImage} />
            </span>
          </div>
          <div className="table-avatar blue-link">
            <h2 className="text-nowrap text-capitalize">
              <span className="fw-bold text-dark">
                {employee.personalInfo?.name?.first || ""}{" "}
                {employee.personalInfo?.name?.middle || ""}{" "}
                {employee.personalInfo?.name?.last || ""}{" "}
              </span>
            </h2>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="table-avatar blue-link">
            <Link to={`profile/${employee._id}`} className="avatar">
              <img alt="" src={profileImage} />
            </Link>
          </div>
          <div className="table-avatar blue-link">
            <h2 className="text-nowrap text-capitalize">
              <Link to={`profile/${employee._id}`}>
                {employee.personalInfo?.name?.first || ""}{" "}
                {employee.personalInfo?.name?.middle || ""}{" "}
                {employee.personalInfo?.name?.last || ""}{" "}
              </Link>
            </h2>
          </div>
        </>
      );
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <Table responsive className="table-custom">
          <thead>
            <tr className="text-nowrap">
              {hideActions ? null : <th></th>}
              <th>No</th>
              <th className="text-left">Name</th>
              <th>EmployeeId</th>
              <th>Designation</th>
              <th>Availability</th>
              {showSalary && <th>Salary</th>}
              <th>Job Grade</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Join Date</th>
              <th>Start Date</th>
            </tr>
          </thead>

          <tbody>
            {searchEmployeeList.map((employee, index) => {
              const displayImage =
                employee?.emergencyInfo && employee?.emergencyInfo?.image;

              const profileImage = displayImage
                ? URLS.backendStatic + "/" + displayImage
                : "/assets/img/profiles/avatar-03.jpg";
              return (
                <tr key={index}>
                  {hideActions ? null : (
                    <td className="text-right">
                      <Dropdown>
                        <Dropdown.Toggle variant="" bsPrefix="">
                          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          popperConfig={{
                            strategy: "fixed",
                          }}
                          renderOnMount
                        >
                          {returnDropDownItems()?.map((el) => (
                            <DropDowns
                              action={() => el.action({ employee })}
                              icon={el.icon}
                              name={el.name}
                            />
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  )}
                  <td>{startIndex + index + 1}</td>
                  <td className="w-100">
                    <div className="d-flex justify-content-start align-items-center">
                      {getEmployeeDirect(employee, profileImage)}
                    </div>
                  </td>
                  <td>{employee?.jobInfo?.employeeId}</td>
                  <td>{employee.jobInfo.title}</td>
                  <td>
                    <p
                      className={`tw-status ${statusColor(
                        employee?.onLeave ? "green" : "blue"
                      )}`}
                    >
                      {employee?.onLeave || "Working"}
                    </p>
                  </td>
                  {showSalary && (
                    <td>
                      {currency(employee.jobInfo?.salary || 0, {
                        symbol: "",
                      }).format()}
                    </td>
                  )}
                  <td>{employee.jobInfo?.grade?.name}</td>
                  <td>{employee.jobInfo?.email}</td>
                  <td>{employee.personalInfo?.phone?.home}</td>
                  <td>{employee.jobInfo?.joinDate}</td>
                  <td>{employee.jobInfo?.startDate}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default React.memo(EmployeeTable);
